import { localizationService } from "common/localization";

// Copies a content preview link (see contentPreviewLink.js) to the clipboard and tells the
// user what happened. Shared by every place that offers a copy-link action so the wording and
// the failure handling stay the same wherever the link is copied from.
//
// A null url means the content can't be linked - the caller should hide its action rather than
// offer one that does nothing - so nothing is copied and nothing is reported.
async function copyContentPreviewLink(rootStore, url) {
    if (!url) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(url);
        rootStore.notificationStore.success(localizationService.t("COMMON.CONTENT_LINK.COPIED"));
        return true;
    } catch (error) {
        rootStore.notificationStore.error(localizationService.t("COMMON.CONTENT_LINK.COPY_ERROR"), error);
        return false;
    }
}

export default copyContentPreviewLink;
